import React from 'react';

export const HCaptchaFooter = React.memo(() => (
  <>
    This site is protected by hCaptcha and its&nbsp;
    <a href={`${window.apiOriginUrl}/hcaptcha-host/privacy`} rel="noreferrer" target="_blank">
      Privacy Policy
    </a>{' '}
    and&nbsp;
    <a href={`${window.apiOriginUrl}/hcaptcha-host/terms`} rel="noreferrer" target="_blank">
      Terms of Service
    </a>{' '}
    apply.
  </>
));
